import styled from "styled-components";
import { Color, Font, breakpoints,ColorDark } from "@/shared/Constants";

export const Container = styled.div `
  h3 {
    font-size: 19px;
    line-height: 24px;
    ${Font.sansLight}

    a {
      width: 300px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${Color.black000};
      border-radius: 50px;

      background-color: ${Color.greyF5F5F5};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background-color:${ColorDark.greySeparator};
        color:${ColorDark.textLight};
        }

      }

      ${breakpoints.phoneTablet} {
        width: 258px;
      }

      ${breakpoints.phone} {
        width: 100%;
      }

      :hover {
        background-color: ${Color.greySeparator};
      }
    }
  }
`;